import url from './urls'

const state = {
  isLoading: false,
  menuGalleries: null,
  yearGalleries: null,
  listGallery: null
}

const mutations = {
  GETMENUS (state) {
    state.isLoading = true

    fetch(url.gallery.list)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.menuGalleries = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETYEAR (state, id) {
    state.isLoading = true

    fetch(url.gallery.year + id)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.yearGalleries = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETLIST (state, params) {
    state.isLoading = true

    fetch(url.gallery.detail + params.id + '/' + params.year)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.listGallery = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  }
}

const actions = {
  getMenus ({ commit }) {
    commit('GETMENUS')
  },

  getYear ({ commit }, id) {
    commit('GETYEAR', id)
  },

  getList ({ commit }, params) {
    commit('GETLIST', params)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
